import { Button, Icon } from '@hubtype/ui-react-web'

import { CountryInfo } from '../../domain/models/content-fields'
import { LanguageInfo } from '../../domain/models/locales/language'
import { TrackEventName, useAnalytics } from '../../UI/analytics'
import { PreviewUrlParams } from '../../UI/types'
import { useRefreshCount } from '../hooks'
import { cleanLocalStoragePreservingPreviewState } from '../utils'

interface StartOverButtonProps {
  isShared: boolean
  selectedLanguage: LanguageInfo
  selectedCountry: CountryInfo
}

export const StartOverButton = ({
  isShared,
  selectedLanguage,
  selectedCountry,
}: StartOverButtonProps) => {
  const analytics = useAnalytics()
  const { refreshCount, urlWithRefreshCount } = useRefreshCount()

  const handleStartOver = () => {
    !isShared && cleanLocalStoragePreservingPreviewState()
    analytics.trackEvent(TrackEventName.PreviewWindowRefresh, {
      number_of_refresh: refreshCount,
    })
    if (!isShared) {
      window.location.href = urlWithRefreshCount
    } else {
      const parsedUrlWithUpdatedParams = new URL(urlWithRefreshCount)

      parsedUrlWithUpdatedParams.searchParams.set(
        PreviewUrlParams.CurrentLocale,
        selectedLanguage.id
      )
      parsedUrlWithUpdatedParams.searchParams.set(
        PreviewUrlParams.CurrentCountry,
        selectedCountry.id
      )

      window.location.href = parsedUrlWithUpdatedParams.toString()
    }
  }

  return (
    <Button intent='secondary' appearance='outline' onPress={handleStartOver}>
      <Icon icon='rotate-right' />
    </Button>
  )
}
